import { motion } from "framer-motion";

export const IconBadge = ({ icon: Icon, dark = false, delay = 0, size = 22 }) => (
  <motion.span
    aria-hidden="true"
    initial={{ opacity: 0, scale: 0.5, rotate: -10 }}
    whileInView={{ opacity: 1, scale: 1, rotate: 0 }}
    viewport={{ once: true, margin: "-40px" }}
    transition={{ type: "spring", stiffness: 180, damping: 16, delay }}
    whileHover={{ scale: 1.1, rotate: 4 }}
    className={`inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-full border ${
      dark ? "border-brand-ivory/25 text-brand-champagne" : "border-brand-brunswick/25 text-brand-brunswick"
    }`}
  >
    <Icon size={size} strokeWidth={1.4} />
  </motion.span>
);
